/* eslint-disable */
export default {
  tollFree: 'Freephone',
  rcvPmiMeetingTitle: '{extensionName}’s video meeting',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
